<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center py-8 justify-center min-h-screen">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-black opacity-50"></div>
      </div>
      <div
        class="bg-white rounded-lg overflow-hidden shadow-xl z-50 px-6 py-6 min-w-[90vw] md:min-w-[40vw]"
      >
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-medium text-gray-800 dark:text-white">
            Actualizar datos del comprobante
          </h2>
          <button
            @click="isActive"
            class="text-gray-500 hover:text-gray-700 w-8 h-8 flex items-center justify-center hover:bg-gray-200 rounded-lg"
          >
            <svg class="w-5 h-5">
              <use href="../../../assets/svg/icon.svg#cancel" />
            </svg>
          </button>
        </div>
        <LoadingForms v-if="!isLoading" />
        <form class="w-full space-y-6" @submit.prevent v-else>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Serie comprobante Físico
              </span>
              <input
                type="text"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500"
                v-model="dataForm.serie"
                placeholder="B001"
                @keydown.enter.prevent
                maxlength="4"
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Serie comprobante Electrónico
              </span>
              <input
                type="text"
                maxlength="3"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 -moz-appearance-none -webkit-appearance-none appearance-none"
                v-model="dataForm.invoice_number"
                placeholder="E31"
                @input="sanitizeElectronicSerieField"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                N° de inicio
              </span>
              <input
                type="text"
                maxlength="10"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 focus:border-blue-500 -moz-appearance-none -webkit-appearance-none appearance-none"
                v-model="dataForm.numberStart"
                placeholder="0000000001"
                inputmode="numeric"
                @input="sanitizeNumericField('numberStart', MAX_SEQUENCE_LENGTH)"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                N° actual
              </span>
              <input
                type="text"
                maxlength="10"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-green-500 focus:border-blue-500 -moz-appearance-none -webkit-appearance-none appearance-none"
                v-model="dataForm.numberCurrent"
                placeholder="0000000001"
                inputmode="numeric"
                @input="sanitizeNumericField('numberCurrent', MAX_SEQUENCE_LENGTH)"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                N° final
              </span>
              <input
                type="text"
                maxlength="10"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-orange-300 focus:border-blue-500 -moz-appearance-none -webkit-appearance-none appearance-none"
                v-model="dataForm.numberFinal"
                placeholder="9999999999"
                inputmode="numeric"
                @input="sanitizeNumericField('numberFinal', MAX_SEQUENCE_LENGTH)"
                @keydown.enter.prevent
              />
            </label>
            <label class="block" v-if="showExpirationDate">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Fecha de vencimiento
              </span>
              <input
                type="date"
                maxlength="8"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-gray-300 focus:border-blue-500 -moz-appearance-none -webkit-appearance-none appearance-none"
                v-model="dataForm.vencimiento"
                placeholder="Fecha de vencimiento"
                @keydown.enter.prevent
              />
            </label>
            <label class="block">
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                N° de envio {{ config.auditingInstitution }}
              </span>
              <input
                type="text"
                maxlength="8"
                class="py-2 px-2 text-sm bg-gray-50 outline-none rounded-lg text-gray-600 w-full border-2 border-gray-300 focus:border-blue-500 -moz-appearance-none -webkit-appearance-none appearance-none"
                v-model="dataForm.numberOfSendingSunat"
                placeholder="N° envio"
                @keydown.enter.prevent
              />
            </label>
            <label
              class="flex flex-col h-6 mr-5 cursor-pointer mb-[3.5rem!important]"
            >
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                ¿Trabajando?
              </span>
              <div
                class="relative inline-flex items-center h-6 mr-5 mt-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  class="sr-only peer"
                  v-model="dataForm.working"
                />
                <div
                  class="w-11 h-6 bg-gray-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:left-[4px] after:bg-white after:border-transparent after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-500"
                ></div>
                <span
                  class="ml-3 text-sm font-medium text-gray-600 dark:text-gray-300"
                >
                  {{ dataForm.working === true ? "Si" : "No" }}
                </span>
              </div>
            </label>
            <label
              class="flex flex-col h-6 mr-5 cursor-pointer mb-[3.5rem!important]"
            >
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                ¿Fijado?
              </span>
              <div
                class="relative inline-flex items-center h-6 mr-5 mt-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  class="sr-only peer"
                  v-model="dataForm.fixed"
                />
                <div
                  class="w-11 h-6 bg-gray-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:left-[4px] after:bg-white after:border-transparent after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-500"
                ></div>
                <span
                  class="ml-3 text-sm font-medium text-gray-600 dark:text-gray-300"
                >
                  {{ dataForm.fixed === true ? "Si" : "No" }}
                </span>
              </div>
            </label>
            <label
              class="flex flex-col h-6 mr-5 cursor-pointer mb-[1rem!important]"
            >
              <span
                class="block mb-2 text-sm font-medium text-gray-800 dark:text-white"
              >
                Estado actual
              </span>
              <div
                class="relative inline-flex items-center h-6 mr-5 mt-2 cursor-pointer"
              >
                <input
                  type="checkbox"
                  class="sr-only peer"
                  v-model="dataForm.state"
                />
                <div
                  class="w-11 h-6 bg-gray-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:left-[4px] after:bg-white after:border-transparent after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-500"
                ></div>
                <span
                  class="ml-3 text-sm font-medium text-gray-600 dark:text-gray-300"
                >
                  {{ dataForm.state === true ? "Activo" : "Inactivo" }}
                </span>
              </div>
            </label>
          </div>

          <p class="text-xs text-gray-500">
            La serie física se configura aparte. La serie electrónica debe ser tipo E32 y los números de inicio, actual y final deben tener 10 dígitos exactos.
          </p>

          <div class="flex mt-[3.5rem!important]">
            <button
              class="bg-blue-500 text-white px-4 py-2 font-semibold text-sm rounded-lg hover:shadow-sm hover:shadow-blue-600 active:scale-95 flex items-center"
              @click="update"
              :disabled="spinner === true"
            >
              <div class="flex items-center" v-if="spinner">
                <svg class="w-4 h-4 mr-3 animate-spin">
                  <use href="../../../assets/svg/icon.svg#spinnerForBlue" />
                </svg>
                Modificando Información
              </div>
              <span v-else>Modificar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { confirmationOfUpdate, errorActions, warningActions } from "@/alerts";
import { observer } from "@/observer";
import axios from "../../../api";
import Swal from "sweetalert2";
import { voucherSupportsExpiration } from "@/utils/voucherExpirationRules";
import config from "/public/apis/config.json";

//componente de loading
import LoadingForms from "@/components/Loadings/LoadingFormsLarge.vue";
export default {
  name: "UpdateVouchers",
  components: {
    LoadingForms,
  },
  props: {
    activeModal: {
      type: Function,
      required: true,
    },
    getdata: {
      type: Function,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const MIN_SEQUENCE_LENGTH = 10;
    const MAX_SEQUENCE_LENGTH = 10;
    const ELECTRONIC_SERIE_MAX_LENGTH = 3;

    async function isActive() {
      await props.activeModal(true);
    }

    const spinner = ref(false);
    const selectedVoucherTypeDescription = ref("");
    const originalConfig = ref({
      numberCurrent: "",
      numberFinal: "",
      vencimiento: "",
    });

    const dataForm = ref({
      serie: "",
      numberStart: "",
      invoice_number: "",
      numberCurrent: "",
      numberFinal: "",
      vencimiento: "",
      working: false,
      fixed: false,
      state: false,
      numberOfSendingSunat: 0,
    });

    // el isLoading se aplica para validar que la api aya sido consumido o cargado al 100 y recien ahi cargamos el componente
    const isLoading = ref(false);
    onMounted(async () => {
      const response = await axios
        .get("comprobantes/" + props.id)
        .catch((error) => errorActions(error));
      const data = await response.data;

      selectedVoucherTypeDescription.value =
        data.tipo_comprobante_descripcion || "";
      dataForm.value.serie = data.serie;
      dataForm.value.numberStart = data.numero_inicio;
      dataForm.value.invoice_number = data.invoice_number;
      dataForm.value.vencimiento = data.vencimiento;
      dataForm.value.numberCurrent = data.numero_actual;
      dataForm.value.numberFinal = data.numero_final;
      dataForm.value.working = data.trabajando === 1 ? true : false;
      dataForm.value.fixed = data.fijado === 1 ? true : false;
      dataForm.value.state = data.estado === 1 ? true : false;
      dataForm.value.numberOfSendingSunat = data.numero_de_envio_sunat;
      originalConfig.value = {
        numberCurrent: data.numero_actual,
        numberFinal: data.numero_final,
        vencimiento: data.vencimiento ?? "",
      };

      if (!voucherSupportsExpiration(selectedVoucherTypeDescription.value)) {
        dataForm.value.vencimiento = "";
        originalConfig.value.vencimiento = "";
      }

      isLoading.value = true;
    });

    const showExpirationDate = computed(() =>
      voucherSupportsExpiration(selectedVoucherTypeDescription.value)
    );

    const sanitizeNumericField = (fieldName, maxLength) => {
      dataForm.value[fieldName] = String(dataForm.value[fieldName] ?? '')
        .replace(/\D/g, '')
        .slice(0, maxLength);
    };

    const sanitizeElectronicSerieField = () => {
      dataForm.value.invoice_number = String(dataForm.value.invoice_number ?? "")
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, ELECTRONIC_SERIE_MAX_LENGTH);
    };

    const isValidSequenceLength = (value) =>
      new RegExp(`^\\d{${MIN_SEQUENCE_LENGTH},${MAX_SEQUENCE_LENGTH}}$`).test(
        String(value ?? '').trim()
      );

    const isValidElectronicSerie = (value) =>
      /^E\d{2}$/.test(
        String(value ?? "").trim().toUpperCase()
      );

    const parseNumericValue = (value) => {
      const parsed = parseInt(value, 10);

      return Number.isNaN(parsed) ? 0 : parsed;
    };

    const confirmSensitiveUpdate = async () => {
      const warnings = [];
      const previousCurrent = parseNumericValue(originalConfig.value.numberCurrent);
      const nextCurrent = parseNumericValue(dataForm.value.numberCurrent);
      const previousFinal = parseNumericValue(originalConfig.value.numberFinal);
      const nextFinal = parseNumericValue(dataForm.value.numberFinal);
      const previousExpiration = originalConfig.value.vencimiento || "";
      const nextExpiration = dataForm.value.vencimiento || "";
      const expirationChanged = showExpirationDate.value && previousExpiration !== nextExpiration;
      const finalChanged = previousFinal !== nextFinal;
      const currentChanged = previousCurrent !== nextCurrent;

      if (expirationChanged && !finalChanged) {
        warnings.push(
          `Se actualizará la fecha del lote actual de <strong>${previousExpiration || "sin fecha"}</strong> a <strong>${nextExpiration || "sin fecha"}</strong>. Los próximos comprobantes pendientes de ese tramo usarán esa nueva fecha, pero los documentos ya emitidos no cambian.`
        );
      }

      if (finalChanged && nextFinal > previousFinal) {
        warnings.push(
          `Se ampliará la secuencia desde <strong>${previousFinal + 1}</strong> hasta <strong>${nextFinal}</strong>. Los comprobantes pendientes hasta el <strong>${previousFinal}</strong> conservarán su vencimiento anterior y el nuevo tramo tomará la fecha <strong>${nextExpiration || previousExpiration || "sin fecha"}</strong>.`
        );
      }

      if (finalChanged && nextFinal < previousFinal) {
        warnings.push(
          `Estás reduciendo el número final de <strong>${previousFinal}</strong> a <strong>${nextFinal}</strong>. Esto puede dejar comprobantes fuera del rango operativo si no coincide con la secuencia autorizada por DGII.`
        );
      }

      if (currentChanged) {
        warnings.push(
          `Estás modificando el número actual de <strong>${previousCurrent}</strong> a <strong>${nextCurrent}</strong>. Si no coincide con el último comprobante realmente emitido, puedes provocar rechazos o inconsistencias fiscales.`
        );
      }

      if (warnings.length <= 0) {
        return true;
      }

      const result = await Swal.fire({
        icon: "warning",
        title: "Cambio sensible en la secuencia",
        html: `${warnings.join("<br><br>")}<br><br><strong>Confirma que deseas continuar con esta actualización.</strong>`,
        showCancelButton: true,
        confirmButtonColor: "#315df5",
        cancelButtonColor: "#dc2626",
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar",
        width: "560px",
      });

      observer.observe(
        document.querySelector(".swal2-container"),
        { box: "content-box" },
        10
      );

      return result.isConfirmed;
    };

    const update = async () => {
      if (dataForm.value.serie <= 2) {
        errorActions(
          "Ingresa un serie para el comprobante, te recomendamos que esa serie sea uno válido"
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      sanitizeElectronicSerieField();
      if (!isValidElectronicSerie(dataForm.value.invoice_number)) {
        errorActions(
          "Ingresa una serie electrónica válida con formato <strong>E + 2 dígitos</strong>. Ejemplos: <strong>E31</strong>, <strong>E32</strong> o <strong>E34</strong>."
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      if (!isValidSequenceLength(dataForm.value.numberStart)) {
        errorActions(
          `Ingresa un <strong>número de inicio</strong> válido de <strong>${MAX_SEQUENCE_LENGTH} dígitos exactos</strong>. La serie electrónica va separada como <strong>E32</strong>.`
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      if (!isValidSequenceLength(dataForm.value.numberCurrent)) {
        errorActions(
          `Ingresa un <strong>número actual</strong> válido de <strong>${MAX_SEQUENCE_LENGTH} dígitos exactos</strong>. La serie electrónica va separada como <strong>E32</strong>.`
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }
      if (!isValidSequenceLength(dataForm.value.numberFinal)) {
        errorActions(
          `Ingresa un <strong>número final</strong> válido de <strong>${MAX_SEQUENCE_LENGTH} dígitos exactos</strong>. La serie electrónica va separada como <strong>E32</strong>.`
        );
        observer.observe(
          document.querySelector(".swal2-container"),
          { box: "content-box" },
          10
        );
        return;
      }

      const confirmed = await confirmSensitiveUpdate();
      if (!confirmed) {
        return;
      }

      spinner.value = true;

      const payload = {
        serie: dataForm.value.serie,
        numberStart: dataForm.value.numberStart,
        invoice_number: String(dataForm.value.invoice_number ?? "").trim().toUpperCase(),
        numberFinal: dataForm.value.numberFinal,
        numberCurrent: dataForm.value.numberCurrent,
        working: dataForm.value.working ? 1 : 0,
        fixed: dataForm.value.fixed ? 1 : 0,
        state: dataForm.value.state ? 1 : 0,
        numberOfSendingSunat: dataForm.value.numberOfSendingSunat,
      };

      if (showExpirationDate.value && dataForm.value.vencimiento) {
        payload.vencimiento = dataForm.value.vencimiento;
      }

      const response = await axios
        .put(
          "comprobantes/" + props.id,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .catch(function (error) {
          errorActions(
            error?.response?.data?.detail ||
              error?.response?.data?.message ||
              error?.message ||
              error
          );
          return null;
        });
      if (!response) {
        spinner.value = false;
        return;
      }
      const data = await response.data;
      if (data.msg === true) {
        await props.activeModal(false);
        await props.getdata();

        if (data.warning) {
          warningActions(data.warning);
        } else {
          confirmationOfUpdate(dataForm.value.serie);
        }
      } else if (data.msg === "Request failed with status code 500") {
        errorActions("Request failed with status code 500");
      } else if (data.status === 404) {
        errorActions(
          `Los datos del comprobante con la serie <trong>${dataForm.value.serie} </strong> que estas intentando actualizar no existe en nuestra base de datos`
        );
      } else if (data.msg === "existSerie") {
        errorActions(
          `Ya existe un comprobante usando la serie <strong>${dataForm.value.serie}</strong>`
        );
        spinner.value = false; //dejando activo al boton
      } else {
        errorActions(
          `Lo sentimos no pudimos actualizar el comprobante con la serie  <trong>${dataForm.value.serie} </strong>`
        );
      }

      observer.observe(
        document.querySelector(".swal2-container"),
        { box: "content-box" },
        10
      );
    };

    return {
      isActive,
      dataForm,
      update,
      isLoading,
      spinner,
      showExpirationDate,
      sanitizeNumericField,
      MIN_SEQUENCE_LENGTH,
      MAX_SEQUENCE_LENGTH,
      sanitizeElectronicSerieField,
      ELECTRONIC_SERIE_MAX_LENGTH,
      config,
    };
  },
};
</script>
